import Layout from '../components/Layout';
import { Mail } from 'lucide-react';

export default function RefundPage() {
  return (
    <Layout>
      <section className="py-20">
        <div className="max-w-3xl mx-auto px-6" data-testid="refund-page">
          <p className="eyebrow mb-4">Policies</p>
          <h1 className="h-display text-4xl md:text-5xl">Return &amp; <em className="font-serif-display italic font-normal text-navy">Refund Policy</em></h1>
          <p className="mt-3 text-sm text-neutral-500">Explore Biz · Last updated {new Date().toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

          <div className="mt-8 space-y-5 text-neutral-700 leading-relaxed text-[15px]">
            <p>If the product doesn't meet your expectations, you can return it to us. Please be aware that a nominal <span className="font-semibold">Return fee of Rs.100</span> will apply. This fee covers the processing of pickup, exchange, and related logistics, including handling and packaging. You will receive a credit note equivalent to the product value for the returned item. This credit note will be visible in the <span className="font-semibold">"My Account"</span> section after logging in.</p>
            <p>All return requests must be initiated within <span className="font-semibold">15 days</span> from the delivery date.</p>

            <h3 className="font-semibold text-lg mt-8">Conditions for Returns</h3>
            <p>The item must be unused and in its original condition, including all packaging. The exchange request must be made within the specified time frame.</p>

            <h3 className="font-semibold text-lg mt-8">Refund Policy</h3>
            <p>Please note that we <span className="font-semibold">do not offer monetary refunds</span>. In case you're returning a product due to dissatisfaction, we will issue a "credit note" that can be used for future purchases on our website. There will be a nominal Return fee of Rs.100 for this service.</p>

            <h3 className="font-semibold text-lg mt-8">Damaged or Defective Products</h3>
            <p>If you receive a damaged or defective item, we offer a <span className="font-semibold">free product exchange</span>. However, if you choose to return the product instead, a Return fee of Rs.100 will be applicable.</p>

            <p className="mt-8">Your satisfaction is important to us, and we appreciate your understanding of our return and refund procedures.</p>

            <div className="mt-8 card-soft p-5 flex items-start gap-3 bg-cream/60 border border-black/5">
              <Mail size={18} className="text-navy mt-0.5" />
              <div className="text-sm">
                <p className="font-semibold">Need to raise a return or refund?</p>
                <p className="text-neutral-600 mt-1">Email us at <a href="mailto:connectnearme1@gmail.com" className="text-navy font-semibold underline" data-testid="refund-email">connectnearme1@gmail.com</a> mentioning your <span className="font-semibold">Order ID</span> and reason for refund / return.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
